import type { FC } from "react";
import { cn } from "@/lib/cn";

export const SkeletonBar: FC<{ className?: string; tone?: "light" | "dark" }> = ({ className, tone = "light" }) => (
  <div className={cn("h-21 rounded-small", tone === "dark" ? "skeleton-bar-dark" : "skeleton-bar-light", className)} />
);
